(function() {
    'use strict';
    angular
        .module('teJHipsterApp')
        .factory('CustomActivity', CustomActivity);

    CustomActivity.$inject = ['$resource', 'DateUtils'];

    function CustomActivity ($resource, DateUtils) {
        var resourceUrl =  'api/custom-activities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationTime = DateUtils.convertDateTimeFromServer(data.creationTime);
                        data.validUntil = DateUtils.convertDateTimeFromServer(data.validUntil);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
